export const editedUpdate = (
    obj,
    payload,
    extraField = null,
    idField = null
) => {
    const newObj = obj ? [...obj] : [];

    const updated = extraField ?
        [
            payload,
            ...deleteFromState(
                newObj,
                payload[extraField][idField ? idField : 'id'],
                extraField
            ),
        ] :
        [
            payload,
            ...deleteFromState(
                newObj,
                payload[idField ? idField : 'id'],
                extraField,
                idField
            ),
        ];

    return updated;
};

export const created = (obj, payload) => {
    const newObj = obj ? [...obj] : [];
    return [payload, ...newObj];
};

export const deleteFromState = (
    obj,
    objId,
    extraField = null,
    idField = null
) => {
    const newObj = obj ? [...obj] : [];
    return newObj.filter((obj) => {
        if (extraField) {
            return obj[extraField][idField ? idField : 'id'] !== objId;
        }
        return obj[idField ? idField : 'id'] !== objId;
    });
};

export const editPaginated = (obj, payload) => {
    const newObj = obj ? {...obj } : { result: [] };
    const results = editedUpdate(newObj['result'], payload);
    newObj['result'] = results;
    newObj['count'] = results.length;
    return newObj;
};

export const createPaginated = (obj, payload) => {
    const newObj = obj ? {...obj } : { result: [] };
    const results = created(newObj['result'], payload);
    newObj['result'] = results;
    newObj['count'] = results.length;
    return newObj;
};

export const deletePaginated = (obj, payload) => {
    const newObj = obj ? {...obj } : { result: [] };
    const results = deleteFromState(newObj['result'], payload);
    newObj['result'] = results;
    newObj['count'] = results.length;
    return newObj;
};